module.exports = __webpack_public_path__ + "img/shan.96d880ff.png";